export default "__VITE_ASSET__BwuosYhi__"